import React from "react";
import cn from "classnames";
import { useIntl } from "react-intl";

import localizeChord from "../../../../../../../common/helpers/localizeChord";

import { Container, Button, MainButton, TopButtons, Handle1, Handle2, Handle3, Handle4, Sup, Sub, Sub1, Sub2 } from "./styles";
import { IProps } from "./interfaces";

const ChordsButton = ({ type, open, handleOpen, handleInput }: IProps) => {
    const intl = useIntl();
    const is7 = type.indexOf("7") > -1;
    let typeText = localizeChord(type, intl).type
    if (type.indexOf("7") > -1 && typeText.indexOf("7") === -1) {
        typeText += "7";
    }
    const invA = localizeChord(is7 ? "D7" : "Da", intl);
    const invB = localizeChord(is7 ? "D5" : "D6", intl);
    const invC = localizeChord(is7 ? "D3" : "D4", intl);
    const invD = localizeChord("D2", intl);
    const isLarge = intl.locale === "el" || intl.locale === "lt" || intl.locale == "et";
    return (
        <Container style={{ zIndex: type === open ? 3 : 1 }}>
            <TopButtons className={cn({ Visible: open === type })}>
                <Button isTop isSide onClick={() => handleInput(`${type.slice(0, 1)}${is7 ? "7" : "a"}`)}>
                    {invA.sup || invA.sub}
                </Button>
                <Button isTop onClick={() => handleInput(`${type.slice(0, 1)}${is7 ? "5" : "6"}`)}>
                    {invB.sub2 && (
                        <>
                            <Sub1>{invB.sub}</Sub1>
                            <Sub2>{invB.sub2}</Sub2>
                        </>
                    )}
                    {!invB.sub2 && invB.sub && invB.sup && (
                        <>
                            <Sup>{invB.sup}</Sup>
                            <Sub>{invB.sub}</Sub>
                        </>
                    )}
                    {invB.sub && !invB.sub2 && !invB.sup && invB.sub}
                    {!invB.sub && invB.sup}
                </Button>
                <Button isTop isSide onClick={() => handleInput(`${type.slice(0, 1)}${is7 ? "3" : "4"}`)}>
                    {invC.sub2 && (
                        <>
                            <Sub1>{invC.sub}</Sub1>
                            <Sub2>{invC.sub2}</Sub2>
                        </>
                    )}
                    {!invC.sub2 && invC.sub && invC.sup && (
                        <>
                            <Sup>{invC.sup}</Sup>
                            <Sub>{invC.sub}</Sub>
                        </>
                    )}
                    {invC.sub && !invC.sub2 && !invC.sup && invC.sub}
                    {!invC.sub && invC.sup}
                </Button>
                {is7 && (
                    <Button isTop isAside onClick={() => handleInput(`${type.slice(0, 1)}${"2"}`)}>
                        {invD.sub2 && (
                            <>
                                <Sub1>{invD.sub}</Sub1>
                                <Sub2>{invD.sub2}</Sub2>
                            </>
                        )}
                        {!invD.sub2 && invD.sub && invD.sup && (
                            <>
                                <Sup>{invD.sup}</Sup>
                                <Sub>{invD.sub}</Sub>
                            </>
                        )}
                        {invD.sub && !invD.sub2 && !invD.sup && invD.sub}
                        {!invD.sub && invD.sup}
                    </Button>
                )}
                <Handle1 />
                <Handle2 />
                <Handle3 />
                {is7 && (
                    <Handle4 />
                )}
            </TopButtons>
            <MainButton isLarge={isLarge}>
                <Button onClick={() => handleOpen(type)} isLarge={isLarge}>{typeText}</Button>
            </MainButton>
        </Container>
    );
};

export default ChordsButton;
